import { render, staticRenderFns } from "./ProjectHeaderPreliminary.vue?vue&type=template&id=39d75072&"
import script from "./ProjectHeaderPreliminary.vue?vue&type=script&lang=js&"
export * from "./ProjectHeaderPreliminary.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHeaderPreliminary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports